import { type ReactNode, memo } from 'react'

import { cn } from '@/shared/lib/cn'

import { FeatureTooltipInfo } from '../types/FeatureTooltipInfo.ts'
import { type FeatureIconProps } from './FeatureIcon.tsx'
import { FeatureTooltipByTooltipInfo } from './FeatureTooltipByTooltipInfo.tsx'

interface FeatureButtonProps {
	ref?: React.Ref<HTMLParagraphElement>
	iconValues: FeatureIconProps
	isExist?: boolean
	tooltipInfo: FeatureTooltipInfo
	onMouseLeave?: () => void
	onMouseEnter?: () => void
	children: ReactNode
	className?: string
}

export const FeatureButton = memo(
	({
		ref,
		className,
		iconValues,
		isExist,
		tooltipInfo,
		onMouseLeave,
		onMouseEnter,
		children
	}: FeatureButtonProps) => {
		return (
			<>
				<span
					className={cn('whitespace-normal', className)}
					ref={ref}
				>
					{children}
				</span>

				<FeatureTooltipByTooltipInfo
					className="self-start"
					onMouseEnter={onMouseEnter}
					onMouseLeave={onMouseLeave}
					iconValues={iconValues}
					tooltipInfo={tooltipInfo}
					isExist={isExist}
				/>
			</>
		)
	}
)

FeatureButton.displayName = 'FeatureButton'
